import { goSolidApi } from "@/composables/useGoSolidApi";

export interface AdminCompany {
  id: number;
  name: string;
  country: string;
  deleted_at?: string | null;
}

/**
 * Loads every company from `GET /api/admin/companies` for the admin company pickers.
 *
 * The endpoint answers with the records either as an array or as an object keyed by id; both are
 * normalized to an array holding only the fields the pickers use.
 *
 * @throws {Error} When the response is not a 200 with a body; request errors propagate as is
 */
export async function fetchAdminCompanies(): Promise<AdminCompany[]> {
  const response = await goSolidApi.get("/api/admin/companies");
  if (response.status !== 200 || !response.data) {
    throw new Error("Unexpected response from API");
  }
  const data = Array.isArray(response.data)
    ? response.data
    : Object.values(response.data);
  return (data as AdminCompany[]).map((c) => ({
    id: c.id,
    name: c.name,
    country: c.country,
    deleted_at: c.deleted_at,
  }));
}
